import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierResdit7421PerformanceReport from '../../components/CarrierResdit7421PerformanceReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarrierResdit7421PerformanceDetailsSelectors';

export function CarrierResdit7421PerformanceDetailsContainer(props) {
  return (
    <CarrierResdit7421PerformanceReport
      reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

CarrierResdit7421PerformanceDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarrierResdit7421PerformanceDetailsContainer);
